import { useEffect, useRef } from 'react';
import { useNotificationsStore } from '@/stores/notifications.store';
import { api } from '@/lib/api';

const POLL_MS = 30_000; // 30s quand l'onglet est visible

// Railway Pro → pas besoin de keepalive, le process ne s'endort plus
// On garde un ping léger toutes les 5min pour détecter les coupures réseau
const KEEPALIVE_MS = 5 * 60_000;

let keepaliveTimer: ReturnType<typeof setInterval> | null = null;

function startKeepalive() {
  if (keepaliveTimer) return;
  keepaliveTimer = setInterval(() => {
    api.get('/health').catch(() => {});
  }, KEEPALIVE_MS);
}

function stopKeepalive() {
  if (keepaliveTimer) { clearInterval(keepaliveTimer); keepaliveTimer = null; }
}

export function useNotificationsPoll() {
  const fetchRef = useRef(useNotificationsStore.getState().fetch);

  useEffect(() => {
    startKeepalive();
    fetchRef.current();

    let timer: ReturnType<typeof setInterval>;

    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => {
        if (!document.hidden) fetchRef.current();
      }, POLL_MS);
    };

    const onVisibility = () => {
      if (document.hidden) {
        clearInterval(timer);
      } else {
        fetchRef.current();
        start();
      }
    };

    start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
      stopKeepalive();
    };
  }, []);

  return useNotificationsStore(s => s.unreadCount);
}
